<template>
  <NuxtLink class="small-card block w-full" :to="to">
    <UCard
      class="h-24 max-xl:h-31 max-md:h-24 ring-0"
      :class="[
        {
          'cursor-pointer': to,
        },
        ui?.root,
      ]"
      :ui="{
        body: twMerge(
          'flex items-center gap-4 max-md:gap-2.75 p-5! max-xl:p-3! pr-2.5! max-xl:pr-1.5!',
          ui?.body,
        ),
      }"
    >
      <CardDirection v-if="slug" :slug="slug" :size="directionSize" />

      <UButton
        v-else-if="icon"
        class="pointer-events-none w-12 h-12"
        :class="ui?.iconWrapper"
        data-slot="iconWrapper"
        :icon="icon"
        variant="soft"
        :ui="{
          leadingIcon: 'w-6 h-6',
        }"
      />

      <div>
        <slot v-if="$slots['top'] || top" name="top">
          <div
            class="mb-1.5"
            :class="[
              {
                'text-neutral-light typo-paragraph-lg-medium': !bottomTop,
                'text-neutral-default typo-paragraph-sm-regular line-clamp-1':
                  bottomTop,
              },
              ,
              ui?.top,
            ]"
            data-slot="top"
          >
            <UTooltip arrow :text="top">
              <span>{{ top }}</span>
            </UTooltip>
          </div>
        </slot>

        <slot v-if="$slots['bottom'] || bottom" name="bottom">
          <div
            :class="[
              {
                'typo-paragraph-sm-regular text-neutral-default line-clamp-1':
                  !bottomTop,
                'text-neutral-light typo-paragraph-lg-medium': bottomTop,
              },
              ui?.bottom,
            ]"
            data-slot="bottom"
          >
            <UTooltip arrow :text="bottom">
              <span>{{ bottom }}</span>
            </UTooltip>
          </div>
        </slot>
      </div>

      <ClientOnly>
        <UButton
          v-if="!noLink"
          class="ml-auto text-neutral-light"
          :class="[
            {
              'pointer-events-none': !to,
            },
            ui?.link,
          ]"
          data-slot="link"
          variant="ghost"
          :size="isTablet || isMobile ? 'sm' : 'xl'"
          icon="i-local-chevron-right"
          :to="to"
        />
      </ClientOnly>
    </UCard>
  </NuxtLink>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'
import type { Slug } from '~/shared'
import CardDirection from './main-page/cards/CardDirection.vue'

defineOptions({
  name: 'SmallCard',
})

withDefaults(
  defineProps<{
    slug?: Slug
    icon?: string
    top?: string
    bottom?: string
    bottomTop?: boolean
    noLink?: boolean
    directionSize?: 'small'
    to?: string
    ui?: {
      root?: string
      body?: string
      slug?: string
      top?: string
      bottom?: string
      icon?: string
      iconWrapper?: string
      link?: string
    }
  }>(),
  {
    noLink: false,
  },
)

const breakpoints = useBreakpointsStore()
const { isTablet, isMobile } = storeToRefs(breakpoints)
</script>

<style lang="scss" scoped>
.direction {
  position: relative;
  width: 56px;
  height: 56px;

  .figure {
    position: absolute;
    z-index: 0;
    width: 40px;
    height: 40px;
    left: 8px;
    top: 8px;
    transform: rotate(45deg);
    border-radius: 8px;
  }

  .direction-image {
    position: absolute;
    width: 42px;
    right: -6px;
    top: 7px;
    z-index: 1;
  }
}
</style>
